import { ecbrRequest } from '../../request/ecbrRequest'

export const orders = {
  getAll: async () => ecbrRequest.get('/orders'),
  purchase: async (order) => ecbrRequest.post('/orders', order)
}
